module.exports = __webpack_public_path__ + "img/black-arrow-right.e48cf5eb.svg";